import { useTranslation } from '@thoughtspot/i18n';
import { create } from '@thoughtspot/logger';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Colors } from '@thoughtspot/radiant-react/widgets/typography';
import Lottie from 'lottie-react';
import React, { useEffect, useState } from 'react';
import styles from '../spotbuild-integration.module.scss';
import { SparkflowLoader } from './sparkflow-loader';
const logger = create('sparkflow-image-panel');
export const ImagePanel = () => {
    const { t } = useTranslation();
    const [animationData, setAnimationData] = useState(null);
    useEffect(() => {
        if (animationData)
            return;
        fetch('/img/lottie/sparkflow-spotter-animation.json')
            .then(res => res.json())
            .then(setAnimationData)
            .catch(error => {
            logger.warn('Failed to load sparkflow animation', error);
        });
    }, [animationData]);
    return (React.createElement(Vertical, { className: styles.imageSection, grow: true, basis: "40%", vAlignContent: "center", hAlignContent: "center" },
        React.createElement("div", { className: styles.onboardingImageWrapper }, animationData ? (React.createElement(Lottie, { animationData: animationData, loop: true, autoplay: true, className: styles.spotterAnimation })) : (React.createElement(SparkflowLoader, { className: styles.loadingIndicator, message: t('sparkflow.build.process.label'), color: Colors.white })))));
};
//# sourceMappingURL=image-panel.js.map